module.exports = __webpack_public_path__ + "img/forgot-password.cda5d10e.svg";